import { Component, Input, SecurityContext, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../../services/utils.service';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { FileService } from '../../services/file.service';

@Component({
  selector: 'preview',
  templateUrl: './preview.component.html',
  styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnChanges {
  @Input() files;
  @ViewChild('pdfViewerOnDemand') pdfViewerOnDemand;
  isEdge = false;

  pdfSrc = [];

  debug(data) {
    return JSON.stringify(data);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.files) {
      //console.log("changens to files", changes.files, this.files, this.files.length, this.files[0]);
      this.openAllFiles();
    }
  }

  constructor(public translate: TranslateService, private _utils: UtilsService, private _sanitizer: DomSanitizer,
    private _fileService: FileService,
    private _http: HttpClient) {
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
      this.isEdge = true;
    }
  }

  get utils() {
    return this._utils;
  }

  ngOnInit() {
    //console.log("preview files oninit", this.files);
    //this.openAllFiles();
  }

  needsConversion(filetype) {
    let ctype = filetype ? filetype.split('/') : '';
    //console.log("open all files 2", ctype, this._fileService.convertibleTypes[ctype[0]], filetype);
    if ((ctype.length == 1) || !this._fileService.convertibleTypes[ctype[0]] || this._fileService.convertibleTypes[ctype[0]].indexOf(ctype[1]) == -1) {
      return false;
    }
    return true;
  }

  openAllFiles() {
    //console.log("open alles files", this.files.length);
    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i].url) {
        if (!this.needsConversion(this.files[i].type)) {
          //console.log("openpdf 1", this.files[i].url, i, this.files[i].name);
          this.openPdf(this.files[i].url || this.files[i].getUrl, i, this.files[i].name);
          /*console.log("sanitize");
          var surl = this._sanitizer.bypassSecurityTrustResourceUrl(this.files[i].url);
          console.log("set url");
          this.pdfSrc[i] = surl;
*/
        }
      } else {
        // just uploaded
        //console.log("just uploaded", i, this.files[i]);
        if (this.files[i].data) {
          if (!this.needsConversion(this.files[i].type)) {
            this.pdfSrc[i] = this.files[i].data;
          }
        }
      }
    }
  }


  getSafeUrl(file) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(file.url);
  }

  private downloadFile(url: string): any {
    //url = '/assets/producthandleiding_nestas_v3.pdf';
    //console.log("download", url);
    return this._http.get(url, { responseType: 'blob' })
      .pipe(
        map((result: any) => {
          //console.log("downloaded");
          return result;
        })
      );
  }

  public openPdf(url, i, filename, retries = 15) {
    // url can be local url or remote http request to an api/pdf file. 
    // E.g: let url = "assets/pdf-sample.pdf";
    // E.g: https://github.com/intbot/ng2-pdfjs-viewer/tree/master/sampledoc/pdf-sample.pdf
    // E.g: http://localhost:3000/api/GetMyPdf
    // Please note, for remote urls to work, CORS should be enabled at the server. Read: https://enable-cors.org/server.html
    //console.log("open pdf", url, retries);
    var preview = this;

    this.downloadFile(url).subscribe(
      (res) => {
        //console.log("create object url");
        var bloburl = URL.createObjectURL(res);
        //console.log("sanitize");
        var surl = this._sanitizer.bypassSecurityTrustResourceUrl(bloburl);

        if (0 && typeof window.navigator.msSaveBlob !== 'undefined') { // IE
          window.navigator.msSaveOrOpenBlob(res, filename);
        } else {
          //this.pdfViewerOnDemand.pdfSrc = bloburl; // pdfSrc can be Blob or Uint8Array
          //console.log("set url");
          this.pdfSrc[i] = surl;
        }

        //this.pdfViewerOnDemand.refresh();
        /*res.arrayBuffer().then(x => {
          console.log("downloaded 2", res, x);
          this.pdfSrc = { 'data': x };
          var u8 = new Uint8Array(x);
          this.pdfViewerOnDemand.pdfSrc = u8; // pdfSrc can be Blob or Uint8Array
        this.pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
        });*/
        //this.pdfViewerOnDemand.src = res; // pdfSrc can be Blob or Uint8Array
        //this.pdfViewerOnDemand.refresh(); // Ask pdf viewer to load/reresh pdf
      }, error => {
        //console.log("down failed, retries", retries);
        if (retries > 0) {
          setTimeout(function () {
            preview.openPdf(url, i, filename, retries - 1);
          }, 2000)
        }
      });
  }

  getSafePdfUrl(file) {
    //console.log("trust url", file.url, this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, this._sanitizer.bypassSecurityTrustResourceUrl(file.url)));
    return this._sanitizer.sanitize(SecurityContext.RESOURCE_URL, this._sanitizer.bypassSecurityTrustResourceUrl(file.url));
  }

  downloadPdf(file) {

  }

  safeEmbed(ct) {
    return ct && ct != 'application/x-zip-compressed' || false;
  }

  onError(error) {
    console.log("error", error);
  }


}
